<ca-conversation-standard-mixed-list
    *ngIf="standardListVisible"
    (conversationIdChange)="onConversationIdChanged($event)"
    (dataLoaded)="onDataLoaded()"
    [compactPlayer]="compactPlayer"
></ca-conversation-standard-mixed-list>
<ca-conversation-card-mixed-list
    *ngIf="cardListVisible"
></ca-conversation-card-mixed-list>
